import { SurveyMode } from '../../../actions/types'
import { LocaleID } from '../../locale/types'
import { IPreviewModuleJumpToQuestion } from '../types'

export const EMULATE_MOBILE_WIDTH = 370
export const EMULATE_MOBILE_HEIGHT = 743

export const PREVIEW_TOOLBAR_CLASS_NAME = 'swidget-preview-toolbar'

export const ESCAPE_LOGIC_START_RE = '\\[\\['
export const ESCAPE_LOGIC_START_PLACEHOLDER = `${String.fromCharCode(0xe100)}${String.fromCharCode(0xf100)}`
export const ESCAPE_LOGIC_START_REPLACE = '['

export const ESCAPE_LOGIC_END_RE = '\\]\\]'
export const ESCAPE_LOGIC_END_PLACEHOLDER = `${String.fromCharCode(0xf100)}${String.fromCharCode(0xe100)}`
export const ESCAPE_LOGIC_END_REPLACE = ']'

export const LOGIC_START_RE = '\\['
export const LOGIC_END_RE = '\\]'

export const HIDE_TEXT = '[hide text]'

const PREVIEW_TOOLBAR_VIEW_OPTIONS: Record<
  SurveyMode,
  Record<LocaleID, { label: string; value: string; disabled?: boolean }[]>
> = {
  [SurveyMode.RESPONDENT]: {},
  [SurveyMode.RESEARCHER]: {},
  [SurveyMode.XRAYS]: {},
  [SurveyMode.BRIDGE]: {} // URL-only, toolbar hidden: no view options
}

export const previewToolbarViewOptions = (mode: SurveyMode, localeID: LocaleID, t: (...path: string[]) => string) => {
  if (!PREVIEW_TOOLBAR_VIEW_OPTIONS[mode]?.[localeID]) {
    switch (mode) {
      case SurveyMode.RESEARCHER: {
        PREVIEW_TOOLBAR_VIEW_OPTIONS[mode][localeID] = [
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showNumbers'), value: 'showNumbers' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showHints'), value: 'showHints' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showLogic'), value: 'showLogic' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showHidden'), value: 'showHidden' }
        ]
        break
      }
      case SurveyMode.XRAYS: {
        PREVIEW_TOOLBAR_VIEW_OPTIONS[mode][localeID] = [
          {
            label: t('preview', 'controls', 'previewOptions', 'options', 'suppressLogic'),
            value: 'suppressLogic',
            disabled: true
          },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showNumbers'), value: 'showNumbers' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showHints'), value: 'showHints' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showLogic'), value: 'showLogic' },
          { label: t('preview', 'controls', 'previewOptions', 'options', 'showHidden'), value: 'showHidden' }
        ]
        break
      }
      default: {
        if (!PREVIEW_TOOLBAR_VIEW_OPTIONS[mode]) {
          PREVIEW_TOOLBAR_VIEW_OPTIONS[mode] = {}
        }
        PREVIEW_TOOLBAR_VIEW_OPTIONS[mode][localeID] = []
        break
      }
    }
  }
  return PREVIEW_TOOLBAR_VIEW_OPTIONS[mode][localeID]
}

export const JUMP_TO_START_OVER_ID = '-start-over-'
export const JUMP_TO_START_OVER_JUMP_OPTION: IPreviewModuleJumpToQuestion = {
  id: JUMP_TO_START_OVER_ID,
  text: 'START OVER',
  type: null,
  canEnter: true,
  disabled: false,
  completed: true,
  action: 'reset'
}
